<template>
    <main>
        <div class="box">
            <div class="mark" @click="hideWait"></div>
            <div class="content">
                <div class="close" @click="hideWait"></div>
                <div class="middle">
                    <div class="tit">您好，欢迎参加2023 戴尔科技峰会</div>
                    <div class="m-tit">尚未开启，敬请期待！</div>
                    <div class="btn-box">
                        <div class="btn" @click="hideWait">确认</div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'wait',
        data() {
            return {}
        },
        components:{

        },
        computed:{

        },
        methods: {
            hideWait(){
                this.util.showWait(false);
            }
        },
        mounted() {
            this.query = this.$route.query;
        },
        destroyed() {
            this.hideWait();
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .box{position: fixed;top:0;left:0;width: 100%;height:100%;z-index: 100;
        .mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.8)}
        .content{width:750px;height:390px;background: url("~@/assets/image/2025/bg-success.png") no-repeat center center;background-size:cover; position:absolute;top:50%;left:50%;transform: translate(-50%,-50%);border-radius: 10px;
            .close{width: 50px;height:50px;position: absolute;top:0;right:0;background: url("~@/assets/image/54.png") no-repeat center center;background-size: 20px;cursor: pointer;transition: background .3s ease;}
            .close:hover{background-image:url("~@/assets/image/53.png");background-size: 20px; transition: background .3s ease;}
            .middle{width:750px;height:390px;text-align: center;color: #232846;
                .tit{font-size:27px;letter-spacing: 2px;margin-top: 30px;}
                .m-tit{font-size: 42px;margin-top: 20px;}
                .btn-box{margin-top: 50px;
                    .btn{width:140px;height:50px;text-align: center;line-height:50px;color:#fff;margin:30px auto 0;cursor: pointer;border-radius: 5px;background: #ec6014}
                }
            }
        }
    }
</style>

